import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sendWebinarInvitation } from '@src/api/endpoints/webinar';
import { queryKeys } from '@src/utils/queryKeys';

import { ISendInvitePayload, ISendInviteResponse } from '@src/webinar/types';

interface ISendInvite {
  isReinvite: boolean;
  onSuccess?: (response: ISendInviteResponse) => void;
  onError?: (error: any) => void;
}

const useSendWebinarInvitation = ({ isReinvite = false, onSuccess, onError }: ISendInvite) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ISendInvitePayload) => sendWebinarInvitation(payload, isReinvite),
    onSuccess: (response, variables) => {
      onSuccess?.(response);

      queryClient.invalidateQueries({
        queryKey: [queryKeys.webinar.attendeesPaginated(variables.roomId)],
      });
      queryClient.invalidateQueries({
        queryKey: [queryKeys.webinar.attendees(variables.roomId)],
      });
    },
    onError: (err: any) => {
      const message = err?.response?.data?.error || err?.message || 'An unexpected error occurred. Please try again.';
      toast.error(message, { icon: false });
      onError?.(message);
    },
  });
};

export default useSendWebinarInvitation;
